import { Component, OnChanges, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { NavigationItem } from 'src/app/models/navigation';

@Component({
  selector: 'app-navigation',
  templateUrl: 'navigation.template.html',
  styleUrls: ['./navigation.component.scss']
})

export class NavigationComponent implements OnChanges {

  @Input() isNavigationOpen: boolean;
  @Input() isPublic: boolean;

  public dropdownIndex = -1;
  public activeRoute: string;
  
  constructor(
    private router: Router,
    private app: ApplicationConfigService,
    public authService: AzureAuthService,
    public configService: ApplicationConfigService
  ) {
      // Watch for route changes
      router.events.subscribe(val => {
        const route: any = val;
        if (route.url) { this.activeRoute = route.url; }
      });
    }

  ngAfterViewInit() {
    
  }

  ngOnChanges() {
  }

  ngOnInit(): void {
    // todo - current signed in user information
    console.log('menu');
    //var menuLinkSelector = '.menu-item.has-sub';
    //var menus = [].slice.call(document.querySelectorAll(menuLinkSelector));
    //console.log(menus);
    //this.handleSidebarMenuToggle(menus);	
  }

  childActive(page: NavigationItem, route:string){
    if (page.route == route) 
    {
      return true;
    };
    if (page.children){
      for (let child of page.children){
        if (child.route == route){
          return true;
        }
      }
    }
    return false;
  }

  logout() {
   this.authService.logout();
  }

  openDropdown(index: number) {
    this.dropdownIndex = index !== this.dropdownIndex ? index : -1;
  }

  checkVisible(item: NavigationItem) : boolean {
    return true;
  }

  toggle(e, page){
    e.preventDefault();
    page.toggled = !page.toggled;
    
    /*var target = this.nextElementSibling;

    menus.map(function(m) {
      var otherTarget = m.nextElementSibling;
      if (otherTarget !== target) {
        otherTarget.style.display = 'none';
        otherTarget.closest('.'+ app.sidebar.menu.itemClass).classList.remove(app.sidebar.menu.expandClass);
      }
    });

    var targetItemElm = target.closest('.'+ app.sidebar.menu.itemClass);

    if (targetItemElm.classList.contains(app.sidebar.menu.expandClass) || (targetItemElm.classList.contains(app.sidebar.menu.activeClass) && !target.style.display)) {
      targetItemElm.classList.remove(app.sidebar.menu.expandClass);
      target.style.display = 'none';
    } else {
      targetItemElm.classList.add(app.sidebar.menu.expandClass);
      target.style.display = 'block';
    }*/
  }

}
